import { useCallback } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { useTranslation } from 'react-i18next'
import { selectHopTimusEnabled } from '@/containers/Login/AuthSelectors'
import { useSnackbarNotification } from '@/shared/tools/notifications/useSnackbarNotification'
import { hopTimusActions } from './hopTimusSagas'
import { selectHopTimusIsLoading } from './hopTimusSelectors'

const useHopTimusButton = () => {
  const dispatch = useDispatch()
  const isEnabled = useSelector(selectHopTimusEnabled)
  const isLoading = useSelector(selectHopTimusIsLoading)
  const { t } = useTranslation()
  const showNotification = useSnackbarNotification()

  const openWidget = useCallback(() => {
    // window.Pulse is the source of truth: PULSE's own loader sets it once mounted.
    if (window.Pulse) {
      window.Pulse.toggle()
      return
    }

    dispatch({
      type: hopTimusActions.ACTIVATE,
      pageUrl: window.location.href,
      unavailableMessage: t('common:hop_timus_unavailable'),
      showNotification,
    })
  }, [dispatch, showNotification, t])

  return { isEnabled, isLoading, openWidget }
}

export default useHopTimusButton
